/**
 * Interface of an audit check document. Received from the backend
 */
export interface AuditCheckDocumentResult {
    /**
     * Audit check name
     */
    check: string;

    /**
     * Audit check id
     */
    key: string;

    /**
     * Audit check type (WARNING...)
     */
    type: string;

    /**
     * Audit check scope (document...)
     */
    scope: string;

    /**
     * Count of documents
     */
    count: number;

    /**
     * Total count of documents
     */
    totalCount: number;
}

/**
 * Interface of an audit check result document.
 * we just need id for now
 */
export type AuditCheckResultDocumentBase = {
    id: string;
};

/**
 * Key to identify the audit check bank
 */
export enum AuditCheckBankKey {
    BankReconciliation = "f6ckVK5uLXpKyft8JwArURpv",
}
